// extracted by mini-css-extract-plugin
export default {"container":"AdminContexts_container__jKxnl","table":"AdminContexts_table__diwh8"};